import { Directive, Input } from "@angular/core";
import { LinkedItemTableCellContext, LinkedItemTableDetailContext } from "./linked-item-table-template.models";

@Directive({ selector: "ng-template[appLinkedItemTableOverview]" })
export class LinkedItemTableOverviewDirective<T> {
    @Input({ alias: "appLinkedItemTableOverview", required: true }) linkedItemTableOverview: (item: T) => string | number;

    static ngTemplateContextGuard<T>(
        _directive: LinkedItemTableOverviewDirective<T>, _context: unknown,
    ): _context is LinkedItemTableCellContext<T> {
        return _context !== null && typeof _context === "object";
    }
}

@Directive({ selector: "ng-template[appLinkedItemTableDetail]" })
export class LinkedItemTableDetailDirective<T, D> {
    @Input({ alias: "appLinkedItemTableDetail", required: true }) linkedItemTableDetail: LinkedItemTableDetailContext<T, D> | null;

    static ngTemplateContextGuard<T, D>(
        _directive: LinkedItemTableDetailDirective<T, D>, _context: unknown,
    ): _context is LinkedItemTableDetailContext<T, D> {
        return _context !== null && typeof _context === "object";
    }
}
